<template>
    <v-list nav dense>
        <v-subheader class="pl-0">
            <v-hover v-slot:default="{ hover }">
                <v-btn small text color="grey darken-1" class="text-caption" @click="$emit('update:expanded', !expanded)">
                    RESOURCES
                    <v-icon v-if="hover" right small>{{ expanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                </v-btn>
            </v-hover>
        </v-subheader>
        <v-expand-transition>
            <div v-show="expanded">
                <v-list-item
                    :class="{ 'ml-2 drawer-active-item': !collapsed }"
                    active-class="primary--text"
                    :input-value="isPoolsRoute"
                    :to="poolsRoute"
                    e2e-sidebar-pools>
                    <v-list-item-icon>
                        <v-tooltip right :disabled="!collapsed">
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">mdi-chart-box-outline</v-icon>
                            </template>
                            <span>Pools</span>
                        </v-tooltip>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>Pools</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action v-if="!collapsed" class="my-0">
                        <PoolCreateMenu offset-x right nudge-top="16" @select="createPool">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn text small v-bind="attrs" v-on="on" @click.stop.prevent class="px-2" min-width="0">
                                    <v-icon small>mdi-plus</v-icon>
                                </v-btn>
                            </template>
                        </PoolCreateMenu>
                    </v-list-item-action>
                </v-list-item>

                <ResourcePoolMenu :collapsed="collapsed" :show-quick-actions="true" />

                <v-list-item
                    v-for="item in visibleReportingTabs"
                    :key="item.to"
                    :class="{ 'ml-5 drawer-active-item': !collapsed }"
                    active-class="primary--text"
                    :to="reportingTabRoute(item.to)">
                    <v-list-item-icon>
                        <v-tooltip right :disabled="!collapsed">
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">{{ item.icon }}</v-icon>
                            </template>
                            <span>{{ item.label }}</span>
                        </v-tooltip>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>{{ item.label }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </div>
        </v-expand-transition>
    </v-list>
</template>

<script>
import { mapState } from 'vuex'
const PoolCreateMenu = () => import('@/modules/user/components/PoolCreateMenu.vue')
const ResourcePoolMenu = () => import('@/modules/user/components/ResourcePoolMenu.vue')

export default {
    name: 'DrawerResourcesSection',
    components: {
        PoolCreateMenu,
        ResourcePoolMenu
    },
    props: {
        collapsed: {
            type: Boolean,
            default: false
        },
        expanded: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            reportingTabs: [
                { icon: 'line_axis', label: 'Overview', to: 'overview' },
                { icon: 'data_usage', label: 'Plan utilization', to: 'plan-utilization', requiresRpManager: true },
                { icon: 'savings', label: 'Credit utilization', to: 'credit-utilization' },
                { icon: 'checklist', label: 'Inventory', to: 'inventory', requiresRpManager: true },
                { icon: 'mdi-server-network-outline', label: 'Node pools', to: 'node-pools', requiresRpManager: true },
                { icon: 'mdi-cloud-outline', label: 'Cloud accounts', to: 'cloud-accounts', requiresRpManager: true }
            ]
        }
    },
    computed: {
        ...mapState('userStore', ['rpManager', 'selectedRP', 'selectedResourcePool']),
        activeResourcePoolId() {
            return this.$route.params.rpid || this.selectedRP?.rpid || this.selectedResourcePool
        },
        visibleReportingTabs() {
            return this.reportingTabs.filter(tab => !tab.requiresRpManager || this.rpManager)
        },
        isPoolsRoute() {
            return (this.$route.name || '').startsWith('user-pools')
        },
        poolsRoute() {
            return {
                name: 'user-pools'
            }
        }
    },
    methods: {
        createPool(type) {
            if (type === 'account') {
                this.$router.push({ name: 'user-pools-create-account' })
                return
            }

            if (type === 'wallet') {
                this.$router.push({ name: 'user-pools-create-wallet' })
            }
        },
        reportingTabRoute(tabTo) {
            const rpid = this.activeResourcePoolId

            if (!rpid) {
                return {
                    name: 'reporting-dashboard'
                }
            }

            const params = {
                rpid,
                startDate: this.$route.params.startDate,
                endDate: this.$route.params.endDate
            }

            if (this.$route.params.sid && this.$route.params.oid) {
                return {
                    name: `reporting-sid-${tabTo}`,
                    params: {
                        ...params,
                        oid: this.$route.params.oid,
                        sid: this.$route.params.sid
                    }
                }
            }

            if (this.$route.params.oid) {
                return {
                    name: `reporting-oid-${tabTo}`,
                    params: {
                        ...params,
                        oid: this.$route.params.oid
                    }
                }
            }

            return {
                name: `reporting-rp-${tabTo}`,
                params
            }
        }
    }
}
</script>
